export const GET_PROMOTIONS = 'GET_PROMOTIONS';
export const GET_PROMOTIONS_LOADING = 'GET_PROMOTIONS_LOADING';
export const GET_PROMOTIONS_ERROR = 'GET_PROMOTIONS_ERROR';

export const GET_PROMOTIONS_ALL_MONTH = 'GET_PROMOTIONS_ALL_MONTH';
export const GET_PROMOTIONS_ALL_MONTH_LOADING = 'GET_PROMOTIONS_ALL_MONTH_LOADING';
export const GET_PROMOTIONS_ALL_MONTH_ERROR = 'GET_PROMOTIONS_ALL_MONTH_ERROR';

export const CREATE_PROMOTIONS = 'CREATE_PROMOTIONS';
export const CREATE_PROMOTIONS_LOADING = 'CREATE_PROMOTIONS_LOADING';
export const CREATE_PROMOTIONS_ERROR = 'CREATE_PROMOTIONS_ERROR';

export const GET_PROMOTIONS_FILTER = 'GET_PROMOTIONS_FILTER';
export const GET_PROMOTIONS_FILTER_LOADING = 'GET_PROMOTIONS_FILTER_LOADING';
export const GET_PROMOTIONS_FILTER_ERROR = 'GET_PROMOTIONS_FILTER_ERROR';

export const GET_PROMOTIONS_BY_ID = 'GET_PROMOTIONS_BY_ID';
export const GET_PROMOTIONS_BY_ID_LOADING = 'GET_PROMOTIONS_BY_ID_LOADING';
export const GET_PROMOTIONS_BY_ID_ERROR = 'GET_PROMOTIONS_BY_ID_ERROR';

export const UPDATE_PROMOTIONS_BY_ID = 'UPDATE_PROMOTIONS_BY_ID';
export const UPDATE_PROMOTIONS_BY_ID_LOADING = 'UPDATE_PROMOTIONS_BY_ID_LOADING';
export const UPDATE_PROMOTIONS_BY_ID_ERROR = 'UPDATE_PROMOTIONS_BY_ID_ERROR';
export const UPDATE_PROMOTIONS_RESET_STATE = 'UPDATE_PROMOTIONS_RESET_STATE';

export const VERIFY_PROMOTION_BY_ID = 'VERIFY_PROMOTION_BY_ID';
export const VERIFY_PROMOTION_BY_ID_LOADING = 'VERIFY_PROMOTION_BY_ID_LOADING';
export const VERIFY_PROMOTION_BY_ID_ERROR = 'VERIFY_PROMOTION_BY_ID_ERROR';
export const VERIFY_PROMOTION_BY_ID_RESET_STATE = 'VERIFY_PROMOTION_BY_ID_RESET_STATE';

export const GET_PROMOTIONS_EXCEL = 'GET_PROMOTIONS_EXCEL';
export const GET_PROMOTIONS_EXCEL_LOADING = 'GET_PROMOTIONS_EXCEL_LOADING';
export const GET_PROMOTIONS_EXCEL_ERROR = 'GET_PROMOTIONS_EXCEL_ERROR';

export const GET_PROMOTIONS_FILTER_EXCEL = 'GET_PROMOTIONS_FILTER_EXCEL';
export const GET_PROMOTIONS_FILTER_EXCEL_LOADING = 'GET_PROMOTIONS_FILTER_EXCEL_LOADING';
export const GET_PROMOTIONS_FILTER_EXCEL_ERROR = 'GET_PROMOTIONS_FILTER_EXCEL_ERROR';
export const PROMOTIONS_EXCEL_RESET_STATE = 'PROMOTIONS_EXCEL_RESET_STATE';

export const PROMOTIONS_RESET_STATE = 'PROMOTIONS_RESET_STATE';